// An asset's margin_rate is a % of the notional (1 = 100x, 2 = 50x, 4 = 25x): the admin reads leverage, the order API works in margin rates.
export const leverageLabel = (marginRate) => {
  const leverage = 100 / marginRate
  return `x${Number.isInteger(leverage) ? leverage : leverage.toFixed(2).replace(/\.?0+$/, '')}`
}
